document.addEventListener('DOMContentLoaded', () => {

    cd = document.querySelector('#cart-drawer');

    const { ref, onMounted, nextTick } = Vue;
    const cdApp = Vue.createApp({
        name: "Cart Drawer",
        setup() {
            const cart = ref(null);

            window.cdGrab = () => {
                fetch('/cart?view=json')
                    .then(response => response.json())
                    .then(data => {
                        cart.value = data;
                        cd.classList.remove('is-loading');
                        Vue.nextTick(() => {
                            updateBubbles();
                            updateDiscount();
                            initAddToCart(cd);
                            if(cd.querySelector('.upsells-mb')) new Slider(cd.querySelector('.upsells-mb[slider]'));
                        })
                    });
            };

            const updateBubbles = () => {
                let bubbles = document.querySelectorAll('.header-icon-cart-bubble');
                bubbles.forEach(bubble => {
                    bubble.textContent = cart.value.nb;
                    if(cart.value.nb > 0) bubble.classList.remove('hidden');
                    else bubble.classList.add('hidden');
                })
            }

            const updateDiscount = () => {
                const code = localStorage.getItem('discount');
                if(code && cd.querySelector('#store-discount')) cd.querySelector('#store-discount').value = code;
            }

            const initAddToCart = () => {
                let forms = cd.querySelectorAll('form');
                forms.forEach(form => {
                    if(!form.getAttribute('action')?.includes('/cart/add')) return;
                    if (!form.handleATCSubmit) {
                        form.handleATCSubmit = (e) => {
                            e.preventDefault();
                            AddToCart(form);
                        };
                    }
            
                    if (form.dataset.eventAttached) {
                        form.removeEventListener('submit', form.handleATCSubmit);
                    }
            
                    form.addEventListener('submit', form.handleATCSubmit);
                    form.dataset.eventAttached = 'true';
                })
            }

            const updateQtt = (line, qtt) => {
                cd.classList.add('is-loading');
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ quantity: qtt, line: line })
                })
                    .then(() => window.cdGrab());
            };

            const applyDiscount = () => {
                let code = cd.querySelector('#store-discount').value;
                if(!code) return;

                cd.classList.add('is-loading');

                fetch(`/discount/${code}`)
                    .then(() => {
                        window.cdGrab();
                        localStorage.setItem('discount', code);
                    })
            }

            onMounted(window.cdGrab);

            return {
                cart,
                updateQtt,
                applyDiscount
            }
        }
    });

    cdApp.mount('#cart-drawer');
})

const cartDrawer = {
    init: function () {
        this.cd = document.querySelector('#cart-drawer');

        document.addEventListener('click', (e) => {
            if(isChild(e.target, '[cart-drawer-opener]')) this.open();
            else if(isChild(e.target, '[cart-drawer-closer]')) this.close();
            else if(isChild(e.target, '[cart-drawer-toggler]')) this.toggle();
            else if (isChild(e.target, '[cd-clear]')) this.clear();
        })
    },

    open: function () {
        setActive(this.cd);
        body.classList.add('menu-open','from-right');
    },

    close: function () {
        unsetActive(this.cd);
        body.classList.remove('menu-open','from-right');
    },

    toggle: function () {
        if(isActive(this.cd)) this.close();
        else (this.open());
    },

    clear: function () {
        fetch('/cart/clear.js')
            .then(() => location.reload())
    }
}

document.addEventListener('DOMContentLoaded', () => {
    cartDrawer.init();
})